import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { authEs } from '@auth/i18n';
import { cashierEs } from '@cashier/i18n';

const resources = {
  es: {
    translation: {
      button: {
        confirm: 'Confirmar',
        enter: 'Ingresar',
      },
      login: {
        password_ph: 'Contraseña',
        user_ph: 'Usuario',
      },
      transactions: {
        filters: {
          errors: {
            maxLength: 'Máximo de caracteres permitidos.',
          },
        },
      },
    },
    auth: authEs,
    cashier: cashierEs,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: 'es',
  ns: ['translation', 'auth', 'cashier'],
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18next;
